import { render, staticRenderFns } from "./chart2.vue?vue&type=template&id=395fadee&scoped=true&"
import script from "./chart2.vue?vue&type=script&lang=js&"
export * from "./chart2.vue?vue&type=script&lang=js&"
import style0 from "./chart2.vue?vue&type=style&index=0&id=395fadee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395fadee",
  null
  
)

export default component.exports